<template>
  <div class="main">
    <!-- 菜单 -->
    <my_menu2 page_name="我的项目" back_type="close" back_icon="md-close"></my_menu2>


    <div class="main2">
      <div v-if="left_menu" class="left_menu_if">
        <div class="project_left_box">
          <Spin fix v-if="table_loading"></Spin>
          <div class="left_project_tab">
            <Tabs v-model="operation_status" @on-click="tabs_click">
              <TabPane label="合作中项目" name="0"></TabPane>
              <TabPane label="停止合作项目" name="1"></TabPane>
            </Tabs>
          </div>
          <div class="search_div">
            <Input size="small" @on-search="search" v-model="search_project_name"
              style="width: 240px; margin-right: 10px" search enter-button placeholder="搜索项目名称" />
          </div>
          <div class="left_project_div_list">
            <div v-for="(item, i) in table_data" :key="i">
              <div :class="i != project_current_index
                ? 'project_list_div'
                : 'project_list_div_click'
                " @click="click_left_project(item, i)">
                <div>
                  <div class="top_div">
                    <div :class="i != project_current_index ? 'project_number' : 'project_number2'
                      ">
                      {{ i + 1 + page * limit - limit }}
                    </div>
                    <div>
                      <span class="project_name_text">{{ item.project_name }}</span>
                    </div>
                  </div>

                  <div class="project_full_name">
                    全称:{{ project_name_long_slice(item.project_full_name) }}
                  </div>
                  <div class="project_full_name">
                    财务:{{ project_name_long_slice(item.project_group_name) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="project_page">
            <span style="font-size:13px;color:#888">
              共{{ total_count }}条
            </span>

            <Page :modelValue="page" :total="total_count" simple page-size="20" @on-change="page_change" />
          </div>
        </div>
      </div>
      <div :class="left_menu ? 'project_right_box' : 'project_right_box2'">
        <div class="right_project_name">
          <div></div>
          <div class="project_name_div2">
            <span class="project_type_tag" :style="'background:' + project_current_item.project_type_color">
              {{ project_current_item.project_type }}</span>{{ project_current_item.project_name }}
            <span class="health_score_tag" :class="health_score_class" @click="open_health_check" title="点击查看项目体检报告">
              <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12h4l2 5 4-10 2 5h6" />
              </svg>
              <span v-if="health_score_text=='无'">
                未体检，建议马上体检
              </span>
              <span v-else>
                近期体检 {{ health_score_text }}
              </span>

            </span>
          </div>

          <span v-if="project_current_item.operation_status == '0'" class="tingzhi_hezuo"
            @click="project_stop">更新为停止</span>
          <span v-if="project_current_item.operation_status == '1'" class="tingzhi_hezuo"
            @click="project_start">更新为正常</span>
        </div>

        <div class="project_right_inner">


          <div class="project_right_box_menu">
            <div @click="click_right_menu(item, i)" :class="i == right_menu_index
              ? 'project_right_box_menu_list2'
              : 'project_right_box_menu_list'
              " v-for="(item, i) in right_menu_list" :key="i"
              :style="i == right_menu_index ? 'background:' + item.color : ''">
              {{ item.name }}
              <div class="menu_hot" v-if="item.is_hot == 1">hot</div>
            </div>
          </div>
          <div class="right_right" v-if="JSON.stringify(project_current_item) != '{}'">
            <check ref="check" @change="check_change"></check>


            <div v-show="right_menu_list[right_menu_index]['type'] == 'mianshi'">
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">本周岗位需求</div>
              </div>
              <div class="external_name">
                对外展示公司名称：<span class="current_need_count" @click="click_update_external_name">{{
                  external_name ? external_name : '暂无名称请尽快更新' }}（点击更新）</span>
              </div>

              <div class="week_need">
                项目本周需求人数：<span class="current_need_count" @click="click_update_need_count(project_current_item)">{{
                  project_need_number }}人（点击更新）</span>
              </div>
              <div class="need_job">
                <div v-for="(need_item, need_index) in project_need_data" :key="need_index"
                  @click="click_update_need_count(project_current_item)" class="need_job_div2">
                  <span class="iconfont icongangwei job_icon"></span>
                  <div>
                    {{ need_item.job_name }} · {{ need_item.need_count }}人 · {{ need_item.salary }}/{{
                      need_item.salary_type }}
                  </div>
                </div>
              </div>
              <div style="height: 10px"></div>
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">长期工 - 面试流程</div>
              </div>
              <div style="margin-top:5px">
              </div>
              <div class="mianshi_box">
                <div class="mianshi_box2" @click="click_count(project_current_item, '待面试')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.daimianshi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">待面试</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '面试中')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.mianshizhong" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">面试中</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '待入职')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dairuzhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">待入职</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '入职')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.ruzhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">入职</div>
                </div>
                <div class="mianshi_box2" @click="click_count(project_current_item, '离职')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.lizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">离职</div>
                </div>
              </div>
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">长期工 - 花名册</div>
              </div>
              <div style="margin-top:5px">
                <div class="jiance_div"
                  v-if="resume_check_dict.resume_error_count > 0 || resume_check_dict.unsigned_idcard_count > 0">
                  <Icon type="md-alert" color="red" size="16" style="margin-right:3px" />在职员工信息检测,点击数字查看详情：
                  <div v-if="resume_check_dict.resume_error_count > 0"><span class="jiance_number"
                      @click="resume_idcard_check_show = true">
                      <Icon type="md-contacts" />{{
                        resume_check_dict.resume_error_count }}人
                    </span>身份证信息不完整。</div>
                  <div v-if="resume_check_dict.unsigned_idcard_count > 0" @click="resume_contract_check_show = true">
                    <span class="jiance_number">
                      <Icon type="md-contacts" />{{
                        resume_check_dict.unsigned_idcard_count }}人
                    </span>合同未签署或已过期。
                  </div>
                </div>
                <div v-else class="jiance_div2">
                  <span class="jiance_number2">
                    <Icon type="md-alert" color="blue" size="16" style="margin-right:3px" />
                    666哇~ 身份证与合同都很完善，没有检测到不完整情况，请继续保持！
                  </span>🤙🤙🤙
                </div>

              </div>

              <div class="mianshi_box">
                <div class="mianshi_box2" @click="click_roster(project_current_item, 0)">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.ruzhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">在职花名册</div>
                </div>
                <div class="mianshi_box2" @click="click_roster(project_current_item, 1)">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.lizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">离职花名册</div>
                </div>
                <div class="mianshi_box2" @click="click_swiper_idcard(project_current_item)">
                  <div>
                    <span class="iconfont iconsfz1"></span>
                  </div>
                  <div class="mianshi_box2_name">刷身份证(NFC)</div>
                </div>
              </div>

              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">短期工 - 花名册</div>
              </div>
              <div style="margin-top:5px">
              </div>
              <div class="mianshi_box">
                <div class="mianshi_box2" @click="click_duanqigong(project_current_item, 'daiqueren')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dqg_daiqueren" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">待确认</div>
                </div>
                <div class="mianshi_box2" @click="click_duanqigong(project_current_item, 'zaizhi')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dqg_zaizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">在职花名册</div>
                </div>
                <div class="mianshi_box2" @click="click_duanqigong(project_current_item, 'lizhi')">
                  <div>
                    <CountUp :end="interview_mainshi_count_dict.dqg_lizhi" :duration="1" ref="count" v-font="18" />
                  </div>
                  <div class="mianshi_box2_name">离职花名册</div>
                </div>
              </div>
              <div class="line_icon_title">
                <div class="line_icon"></div>
                <div class="line_name">二维码信息收集</div>
              </div>
              <div>
                <div class="mianshi_box_form" @click="universal_form(project_current_item)">
                  <div class="mianshi_box2_name">去创建</div>
                </div>
              </div>
              <div style="margin-top:5px">
              </div>
              <interview_data ref="interview_data"></interview_data>
              <project_setting ref="project_setting"></project_setting>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'basic'">

              <project_basic_info ref="project_basic_info" @change="basic_info_change"
                @project_type_change="project_type_change" @location_change="location_change"></project_basic_info>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'jiezhi'">
              <jiezhi_data ref="jiezhi_data"></jiezhi_data>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'hetong'">
              <contract_data ref="contract_data"></contract_data>
              <insurance_data ref="insurance_data"></insurance_data>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'kaipiao'">
              <kaipiao ref="kaipiao"></kaipiao>
              <project_payment ref="project_payment_component"></project_payment>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'sushe'">
              <project_dormitory ref="project_dormitory"></project_dormitory>
            </div>
            <div v-show="right_menu_list[right_menu_index]['type'] == 'cloud_disk'">
              <cloud_disk ref="cloud_disk"></cloud_disk>
            </div>
          </div>
        </div>

        <!-- 体检风险告警（原生弹窗，仅覆盖右侧项目信息区域） -->
        <div v-if="health_risk_show" class="hc-risk-mask" @click.self="health_risk_show = false">
          <div class="hc-risk-card">
            <button type="button" class="hc-risk-close" aria-label="关闭" @click="health_risk_show = false">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round">
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>

            <div class="hc-risk-icon">
              <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="#fff" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 3 2.5 20h19z" />
                <path d="M12 9v5" />
                <path d="M12 17.3v.2" />
              </svg>
            </div>

            <div class="hc-risk-heading">项目体检风险告警</div>

            <!-- <div class="hc-risk-heading">{{ health_risk_project_name +'风险告警' || '—' }}</div> -->

            <div class="hc-risk-score">{{ health_risk_score }}<span>分</span></div>

            <div class="hc-risk-pill"><i></i>低于 75 分风险线 · 高危风险</div>

            <div class="hc-risk-tip">
              <b>{{health_risk_project_name}}，项目体检分数过低</b>，存在用工合规风险，请尽快前往处理，避免风险扩大。
            </div>

            <button type="button" class="hc-risk-action" @click="view_health_report">去查看</button>
          </div>
        </div>
      </div>

      <Modal v-model="update_external_name_show" title="对外显示名称更新" :footer-hide="true" width="500">
        <Alert type="success">此名称将显示在【大湘速聘】小程序端，供求职者展示</Alert>

        <div class="need_job_inner_div">
          <Input v-model="update_external_name" placeholder="输入向求职者展示名称，例：xxx公司" style="width: 450px" />
        </div>
        <div class="need_button_div">
          <Button type="primary" style="font-size: 12px" @click="update_external_name_request">确认更新</Button>
        </div>
      </Modal>

      <Modal v-model="need_update_show" title="本周需求更新(每周一更新)" :footer-hide="true" width="500">
        <div class="need_update_title">该项目本周的岗位需求，请如实填写真实信息。用途：1、预约面试时供招聘团队选择岗位。 2、在【大湘速聘】小程序向求职者公开展示招聘信息。</div>
        <!-- <div class="people_count_div">
          <span style="width: 100px">需求人数：</span>
          <Input v-model="update_week_count" />
        </div> -->

        <div class="need_job_main">
          <div v-for="(item, i) in update_need_job_list" :key="i" class="need_job_div">

            <div class="need_job_index">
              {{ i + 1 }}
            </div>
            <div class="need_job_box">
              <!-- <div class="need_job_inner_div">
                <div class="need_job_title">岗位类型：</div>
                <Select v-model="item.job_type" style="width:250px" size="small">
                  <Option v-for="item in job_status_options" :value="item.value" :key="item.value">{{ item.label }}
                  </Option>
                </Select>
              </div> -->

              <div class="need_job_inner_div">
                <div class="need_job_title">岗位名称：</div>
                <Input size="small" v-model="item.job_name" placeholder="输入岗位名称，例：叉车工" style="width: 250px" />
              </div>
              <div class="need_job_inner_div">
                <div class="need_job_title">岗位需求人数：</div>
                <InputNumber size="small" v-model="item.need_count" />
                <span style="font-size: 12px;color:#888;">&nbsp;人</span>

              </div>
              <div class="need_job_inner_div">
                <div class="need_job_title">岗位工资标准：</div>
                <InputNumber size="small" v-model="item.salary" />
                <span style="font-size: 12px;color:#888;">&nbsp;元</span>
                <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                <Select size="small" v-model="item.salary_type" style="width:100px">
                  <Option v-for="item in need_salary_type_list" :value="item.value" :key="item.value">{{ item.label }}
                  </Option>
                </Select>

              </div>
            </div>

            <div>
              <div class="del_job" @click="del_need_job(item, i)">
                <Icon type="ios-trash-outline" color="white" size="18" />
                <span style="font-size: 13px;">删除</span>
              </div>
            </div>

          </div>
          <div class="need_job_btn_div" @click="add_nedd_job">
            <Icon type="ios-add-circle-outline" size="18" />&nbsp;添加岗位
          </div>
        </div>

        <div class="need_button_div">
          <Button type="primary" style="font-size: 12px" @click="update_need_data_first">确认更新</Button>
        </div>
      </Modal>

      <!-- <Modal v-model="project_introduction_show" title="项目介绍完善率过低" :footer-hide="true" width="400">
        <div class="project_introduction">
          当前项目【{{ current_item.project_name }}】，项目介绍完善率：{{
            current_item.percentage_of_perfection
          }}%
        </div>

        <div class="need_update_title">
          检测到当前项目介绍完善率小于80%，完善后有助招聘人员更好的了解项目情况，请先点击前往完善一下!
        </div>

        <div class="need_button_div">
          <Button style="font-size: 12px; margin-right: 10px" @click="to_project_interview">等会再完善（剩余次数{{
            current_item.max_skip_wanshan - current_item.current_skip_wanshan
          }}）</Button>
          <Button type="primary" style="font-size: 12px" @click="to_project_introduction">去完善项目介绍</Button>
        </div>
      </Modal> -->
    </div>
    <Drawer title="员工身份证未完善详情" v-model="resume_idcard_check_show" width="400px">
      <div>
        <Table :columns="resume_columns" size="small" :data="resume_check_dict.resume_basic_list"></Table>

      </div>
    </Drawer>

    <Drawer title="员工合同未签署详情" v-model="resume_contract_check_show" width="600px">
      <div>
        <Table :columns="resume_contract_columns2" size="small" :data="resume_check_dict.unsigned_item_list">
          <template #action="{ row }">
            <span class="contract_span" @click="click_contract_item(row)">查看合同</span>
          </template>

        </Table>
      </div>
    </Drawer>

    <!-- 项目体检报告 -->
    <health_check ref="health_check" @action="on_health_action"></health_check>
  </div>
</template>

<script>
import my_menu from "@/component/menu/menu.vue";
import my_menu2 from "@/component/menu/menu2.vue";
import { http, open_new_page } from "@/utils/http.js";
import merge from "webpack-merge";
import intro1 from "./component/intro/intro1.vue";

import project_basic_info from "@/views/workbench/project_detail/component/project_basic_info.vue";
import jiezhi_data from "@/views/workbench/project_detail/component/jiezhi_data.vue";
import contract_data from "@/views/workbench/project_detail/component/contract_data.vue";
import insurance_data from "@/views/workbench/project_detail/component/insurance_data.vue";
import project_payment from "@/views/workbench/project_detail/component/payment.vue";
import kaipiao from "@/views/workbench/project_detail/component/kaipiao.vue";
import interview_data from "@/views/workbench/project_detail/component/interview_data.vue";
import project_setting from "@/views/workbench/project_detail/component/project_setting.vue";
import check from "./component/check.vue";
import health_check from "./component/health_check.vue";
import project_dormitory from '@/views/workbench/project_detail/component/project_dormitory.vue'
import cloud_disk from '@/views/workbench/my_project/component/cloud_disk.vue'

export default {
  components: {
    my_menu,
    my_menu2,
    intro1,
    project_basic_info,
    jiezhi_data,
    contract_data,
    insurance_data,
    project_payment,
    kaipiao,
    interview_data,
    project_setting,
    check,
    health_check,
    project_dormitory,
    cloud_disk
  },

  data() {
    return {
      textTitle: "项目列表",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      left_menu: true,

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,
      job_status_options: [
        { 'label': '小时工', 'value': 'xiaoshi' },
        { 'label': '派遣工', 'value': 'paiqian' },
        { 'label': '计件工', 'value': 'jijian' },
        { 'label': '社保代理', 'value': 'shebaodaili' },
        { 'label': '代发工资', 'value': 'daifagongzi' },
      ],
      right_menu_index: 0,
      right_menu_list: [
        {
          name: "面试 | 入职",
          type: "mianshi",
          color: "#0466dd",
        },
        {
          type: "basic",
          name: "项目信息",
          color: "#ef7a82",
        },
        {
          type: "jiezhi",
          name: "借支 | 关系解除",
          color: "#33CC33",
        },
        {
          type: "hetong",
          name: "合同 | 保险",
          color: "#e51818",
        },
        {
          type: "kaipiao",
          name: "开票 | 发薪",
          color: "#f17409",
        },
        {
          type: "sushe",
          name: "员工宿舍",
          color: "#f17409",
        },
        {
          type: "cloud_disk",
          name: "项目云盘",
          color: "#08e083",
          is_hot: 1
        },
      ],

      current_project_id: "",
      tabs_append: "",
      total_count: 0,
      limit: 20,
      table_loading: false,
      project_current_index: 0,
      project_current_item: {},

      // 项目体检分数（由 health_check 组件隐藏式取数返回）
      health_score: null,
      // 体检风险告警弹窗
      health_risk_show: false,
      health_risk_score: 0,
      health_risk_project_name: "",
      // 本次页面会话中已提醒过的项目（刷新页面后重置）
      health_warned_project_ids: [],

      project_name: "",
      project_id: "",
      search_project_name: "",

      guidance_type_id: "",

      need_update_show: false,
      update_week_count: "",
      update_need_job_list: [

      ],
      need_salary_type_list: [
        {
          value: '小时',
          label: '小时'
        },
        {
          value: '天',
          label: '天'
        },
        {
          value: '月',
          label: '月'
        }, {
          value: '件',
          label: '件'
        },

      ],

      update_need_item: {},

      operation_status: "0",
      table_selection_list: [],

      project_introduction_show: false,
      current_item: {},
      interview_status: 0,
      interview_mainshi_count_dict: {
        daimianshi: -1,
        mianshizhong: -1,
        dairuzhi: -1,
        ruzhi: -1,
        lizhi: -1,
        dqg_daiqueren: -1,
        dqg_zaizhi: -1,
        dqg_lizhi: -1,
      },


      //简历检测
      resume_check_dict: {},
      resume_columns: [{
        'title': '姓名',
        'key': 'name'
      },
      {
        'title': '身份证实名',
        'key': 'is_certification_fmt'
      },
      {
        'title': '身份证照片',
        'key': 'idcard_img_status_fmt'
      }],
      resume_idcard_check_show: false,

      resume_contract_check_show: false,

      resume_contract_columns2: [{
        'title': '姓名',
        'key': 'name',
        'width': 120
      },
      {
        'title': '身份证号',
        'key': 'idcard'
      },
      {
        'title': '状态说明',
        'key': 'status'
      },
      {
        'title': '操作',
        'slot': 'action',
        'width': 100
      }
      ],
      external_name: '',
      update_external_name_show: false,
      update_external_name: '',
      update_external_project_id: '',

      project_need_data: [],
      project_need_update_flag: false,
      project_need_number: 0



    };
  },

  computed: {
    // 体检分数显示文本：-1 显示"未体检"，null 显示"--"
    health_score_text() {
      if (this.health_score === null || this.health_score === undefined) return "--";
      if (this.health_score == -1) return "无";
      return this.health_score + '分';
    },
    // 体检分数对应的颜色档位：>=90 绿、>=75 橙、其余红；未体检/加载中灰色
    health_score_class() {
      const s = this.health_score;
      if (s === null || s === undefined || s == -1) return "score-loading";
      if (s >= 90) return "";
      if (s >= 75) return "score-warn";
      return "score-err";
    }
  },

  created() {


    var query = this.$route.query;
    var list_page = query.list_page;
    var list_index = query.list_index;
    var search_project_name = query.search_project_name;

    if (list_index) {
      this.project_current_index = list_index;
      this.updateQueryParam('list_index', list_index)
    } else {
      this.updateQueryParam('list_index', '0')
    }
    if (list_page) {
      this.page = list_page;
      this.updateQueryParam('list_page', list_page)
    } else {
      this.updateQueryParam('list_page', '1')
    }
    if (search_project_name) {
      this.search_project_name = search_project_name
      this.updateQueryParam('search_project_name', search_project_name)
    } else {
      this.updateQueryParam('search_project_name', '')
    }

  },

  mounted() {
    var that = this;



    var query = this.$route.query;
    var project_id = query.project_id;
    if (project_id) {
      this.current_project_id = project_id;
      this.left_menu = false
    } else {
      this.left_menu = true
    }

    var tabs_append = query.tabs_append;
    if (tabs_append) {
      this.tabs_append = tabs_append;
    } else {
      this.get_my_project_list();
    }

    var project_name = query.project_name;
    if (project_name) {
      this.project_name = project_name;
    }

    this.update_tabs();

    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };
  },

  methods: {

    //体检总事件
    on_health_action( e ) {
      console.log(e)

      
    },
    update_external_name_request() {
      if (this.update_external_name == '') {
        this.$Message.error('请输入名称')
        return
      }
      let that = this
      var obj = {
        project_id: this.update_external_project_id,
        external_name: this.update_external_name,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/project_detail/need_data/external_name_update", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.update_external_name_show = false
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_project_need_data()
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_update_external_name() {
      this.update_external_name_show = true
      this.update_external_name = this.external_name
      this.update_external_project_id = this.project_current_item.project_id

    },

    location_change(e) {
      console.log('项目坐标变化2', e)

      this.$refs.check.open(e.project_id)


    },

    del_need_job(item, index) {
      this.update_need_job_list.splice(index, 1)
    },

    click_contract_item(row) {
      var url = 'https://contract.daxiangsys.com/contract_manage/search/detail?name=&phone=&idcard=' + row.idcard + '&project_id=' + row.project_id
      open_new_page(url)
    },


    check_change(status) {

      console.log('检测变化', status)
      if (status == 'week_need_status') {
        // alert('周需求更新')
        this.click_update_need_count(this.project_current_item)

      }
      if (status == 'project_job') {
        // this.$refs.project_job.click_add_job();
        this.$refs.project_basic_info.click_add_job(this.project_current_item.project_id);
      }

      if (status == 'project_contract') {
        this.$refs.project_basic_info.click_business_contract(this.project_current_item.project_id);
      }
      if (status == 'percentage_of_perfection') {
        this.$refs.project_basic_info.to_project_introduction(this.project_current_item.project_id);
      }
      if (status == 'project_subject') {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);

        this.$refs.project_basic_info.update_subject();
      }
      if (status == 'project_place') {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);

        this.$refs.project_basic_info.update_place_click();
      }
      if (status == 'dormitory') {
        this.$refs.project_dormitory.click_add_dormitory(this.project_current_item.project_id)

      }
      if (status == 'market_share') {
        // 市占率
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.click_add_market_share(this.project_current_item.project_id);

      }
      if (status == 'project_data_user') {
        // 员工数据用户
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.open_drawer(this.project_current_item.project_id);

      }
      if (status == 'gaozhishu_count') {
        // 员工数据用户
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.click_add_gaozhishu(this.project_current_item.project_id);

      }
      if (status == 'project_location') {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
        this.$refs.project_basic_info.update_project_loaction(this.project_current_item.project_id);


      }


    },
    click_duanqi_roster(item, status) {
      // this.$Message.warning("正在努力开发中，近期上线，敬请期待!");
      console.log(item);
      this.$router.push({
        path: "/roster_manage/duanqi_roster",
        query: {
          project_id: item.project_id,
          project_name: item.project_name,
          job_status: status,
        },
      });
    },
    click_right_menu(item, i) {
      this.right_menu_index = i;
      console.log(this.project_current_item);
      console.log(this.$refs.project_basic_info);

      //
      console.log(123, item);

      // this.$refs.project_basic_info.get_data(this.project_current_item.project_id);
      if (item.type == "mianshi") {
        console.log("面试入职");
        this.update_interview_num();
        this.$refs.interview_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );

        this.$refs.project_setting.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
        this.get_project_need_data()
        // this.$refs.project_job.open(
        //   this.project_current_item.project_id,
        //   this.project_current_item.project_name
        // );
      }
      if (item.type == "basic") {
        this.$refs.project_basic_info.open(this.project_current_item.project_id);
      }
      if (item.type == "jiezhi") {
        console.log("刷新员工借支");
        // 员工借支
        this.$refs.jiezhi_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == "hetong") {
        // 员工合同数据
        this.$refs.contract_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
        this.$refs.insurance_data.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == "kaipiao") {
        // 开票
        this.$refs.kaipiao.open(this.project_current_item.project_id);
        this.$refs.project_payment_component.open(
          this.project_current_item.project_id,
          this.project_current_item.project_name
        );
      }
      if (item.type == 'sushe') {
        this.$refs.project_dormitory.open(this.project_current_item.project_id)
      }
      if (item.type == 'cloud_disk') {
        this.$refs.cloud_disk.open(this.project_current_item.project_id)
      }
      // var that = this
      // setTimeout(function(){
      //   this.$refs.project_basic_info.open();
      // },1000)
    },

    table_selection_change(e) {
      this.table_selection_list = e;
    },

    //项目停止
    project_stop() {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "正在停止项目，停止后可在停止项目列表中查看或重新启动，是否继续？",
        onOk: () => {
          that.stop_http();
        },
        onCancel: () => { },
      });
    },



    stop_http() {
      var that = this;

      var obj = {
        project_id_list: [this.project_current_item.project_id],
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/stop_project", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.get_my_project_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.table_selection_list = [];
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //项目开启
    project_start() {
      var that = this;

      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "正在启动项目，启动后可在正常项目列表中查看或重新停止，是否继续？",
        onOk: () => {
          that.start_http();
        },
        onCancel: () => { },
      });
    },

    start_http() {
      // if (this.table_selection_list.length == 0) {
      //   this.$Message.error("请至少选择一个项目");
      //   return;
      // }

      // var project_id_list = [];
      // for (var i = 0; i < this.table_selection_list.length; i++) {
      //   var pid = this.table_selection_list[i]["project_id"];
      //   project_id_list.push(pid);
      // }

      var that = this;

      var obj = {
        project_id_list: [this.project_current_item.project_id],
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/start_project", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_selection_list = [];
            that.get_my_project_list();
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_need_data_first() {
      // if (this.update_week_count == "") {
      //   this.$Message.error("请输入周需求人数");
      //   return;
      // }
      var that = this;
      // var reg = /^[0-9]+$/;
      // var result = reg.test(this.update_week_count);
      // console.log(result);
      // console.log(this.update_week_count);
      // if (!result) {
      //   this.$Message.error("请输入整数");
      //   return;
      // }
      // var total_count = 0
      // for(var i =0;i<this.update_need_job_list.length;i++){
      //   var count = this.update_need_job_list[i]['need_count']
      //   total_count+=count
      // }

      if (this.update_need_job_list.length == 0) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>当前周需求数为0，真的要更新为无需求吗？</p>",
          onOk: () => {
            that.update_need_data();
          },
          onCancel: () => { },
        });
      } else {
        that.update_need_data();
      }

    },

    //需求数据更新
    update_need_data() {
      var that = this;

      var obj = {
        project_id: this.update_need_item.project_id,
        need_job_list: this.update_need_job_list
      };
      http(
        "post",
        process.env.VUE_APP_HOST +
        "/my_project/project_detail/need_data/week_need_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.get_my_project_list();
            that.need_update_show = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search() {
      this.page = 1;
      this.project_current_index = 0;
      this.get_my_project_list();

      this.updateQueryParam('search_project_name', this.search_project_name)
    },

    updateQueryParam(key, value) {
      var that = this
      setTimeout(() => {
        // 创建一个新的查询参数对象
        let newQuery = { ...that.$route.query };
        // 设置或修改查询参数
        newQuery[key] = value;
        // 使用`this.$router.push`来更新URL的查询参数
        that.$router.push({ path: that.$route.path, query: newQuery });
      }, 50);
    },

    page_change(e) {
      this.page = e;
      this.project_current_index = 0;
      this.updateQueryParam('list_index', 0)
      this.table_selection_list = [];
      this.get_my_project_list();
      this.updateQueryParam('list_page', e)

    },

    click_duanqigong(row, status) {
      var project_id = row.project_id;

      open_new_page(
        "/roster_manage/duanqi_roster?project_id=" +
        project_id +
        "&job_status=" +
        status +
        "&project_name=" +
        row.project_name
      );
    },

    click_roster(row, status) {
      console.log(row);
      var project_id = row.project_id;
      open_new_page(
        "/roster_manage/detail?project_id=" +
        project_id +
        "&job_status=" +
        status +
        "&project_name=" +
        row.project_name
      );
    },

    update_tabs() {
      if (this.tabs_append == "") {
        return;
      }
      this.tabs_item_list.push({ name: this.tabs_append });
      this.tabs_index = String(this.tabs_item_list.length - 1);
    },

    //点击面试人数
    click_count(item, status) {
      // this.need_update_show = true;
      var that = this;
      this.current_item = item;
      // 更新周需求时使用的item
      this.update_need_item = item
      this.interview_status = status;
      var route = that.$route;
      //跳转到面试流程页
      var path =
        route.path +
        "/detail" +
        "?tabs_append=" +
        that.interview_status +
        "&project_id=" +
        that.current_item.project_id +
        "&project_name=" +
        that.current_item.project_name;

      console.log(this.project_need_update_flag)
      // 如果周需求更新直接进入，未更新提示更新
      if (this.project_need_update_flag) {
        open_new_page(path, "_blank");

      } else {

        if (this.project_need_data.length > 0) {
          this.update_need_job_list = JSON.parse(JSON.stringify(this.project_need_data))
        } else {
          this.update_need_job_list = [{
            job_name: '',
            need_count: 15, salary_type: '小时', salary: 20, 'job_type': ''
          }]
        }
        this.need_update_show = true;
      }

    },

    // 跳转到项目介绍
    to_project_introduction() {
      open_new_page("/project_introduction?project_id=" + this.current_item.project_id);
    },

    // 跳转到面试流程
    to_project_interview() {
      this.skip_wanshan(this.current_item.project_id);
    },

    //点击更新周需求
    click_update_need_count(item) {
      console.log('点击更新周需求', item)
      this.update_need_item = item;

      // 回显需求岗位列表
      if (this.project_need_data.length > 0) {
        this.update_need_job_list = JSON.parse(JSON.stringify(this.project_need_data))
      } else {
        this.update_need_job_list = [{
          job_name: '',
          need_count: 15, salary_type: '小时', salary: 20, 'job_type': ''
        }]
      }
      this.need_update_show = true;
    },

    click_project_data(item) {
      // var route = this.$route
      var path = "/workbench/project_detail" + "?project_id=" + item.project_id;
      // // 打开新窗口
      open_new_page(path);
    },

    //点击项目名称
    click_project_name(item, status) {
      this.current_project_id = item.project_id;
      this.$router.push({
        query: merge(this.$route.query, {
          tabs_append: status,
          project_id: this.current_project_id,
        }),
      });
      this.tabs_append = status;

      this.update_tabs();
    },

    tabs_click(item) {
      this.page = 1;
      this.get_my_project_list();
      // console.log(item)
      // console.log(e)

      // if (e == 0) {
      //     this.tabs_item_list = [{ name: '项目列表' }]
      //     this.tabs_index = 0
      //     // 置0
      //     this.daimianshi_show = false
      //     this.mianshizhong_show = false
      //     this.$router.push({
      //         query: merge({}, {})
      //     })
      //     this.get_my_project_list()
      // }
    },

    //入职信息完整检测
    entry_resume_status_check() {
      var that = this;
      console.log("入职信息完整检测");
      var obj = {
        project_id: this.project_current_item.project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/check_entry_people_information", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.resume_check_dict = res.data
          }

        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    //项目需求列表
    get_project_need_data() {
      var that = this;
      console.log("项目需求列表");
      var obj = {
        project_id: this.project_current_item.project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/project_need_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.project_need_data = res.data.need_list
            that.project_need_number = res.data.need_count
            that.project_need_update_flag = res.data.update_need_flag
            that.external_name = res.data.external_name
          }

        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },


    update_interview_num() {
      var that = this;
      setTimeout(function () {
        that.get_my_project_count_v2("daimianshi");
      }, 800);
      setTimeout(function () {
        that.get_my_project_count_v2("mianshizhong");
      }, 500);
      setTimeout(function () {
        that.get_my_project_count_v2("dairuzhi");
      }, 800);
      setTimeout(function () {
        that.get_my_project_count_v2("ruzhi");
      }, 1000);
      setTimeout(function () {
        that.get_my_project_count_v2("lizhi");
      }, 1200);
      setTimeout(function () {
        that.get_my_project_count_v2("dqg_daiqueren");
      }, 1000);
      setTimeout(function () {
        that.get_my_project_count_v2("dqg_zaizhi");
      }, 1000);
      setTimeout(function () {
        that.get_my_project_count_v2("dqg_lizhi");
      }, 1000);
      setTimeout(function () {
        that.entry_resume_status_check();
      }, 1000);



      setTimeout(function () {
        that.$refs.interview_data.open(
          that.project_current_item.project_id,
          that.project_current_item.project_name
        );

        that.$refs.project_setting.open(
          that.project_current_item.project_id,
          that.project_current_item.project_name
        );

        // that.$refs.project_job.open(
        //   that.project_current_item.project_id,
        //   that.project_current_item.project_name
        // );
      }, 500);
    },

    //获取项目列表
    get_my_project_list() {
      var that = this;
      var obj = {
        page: Number(this.page),
        project_name: this.search_project_name,
        project_id: this.current_project_id,
        operation_status: this.operation_status,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/my_project/project_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            console.log('--------project-list', res.data)
            that.table_data = res.data.project_list;
            that.columns = res.data.columns;
            that.limit = res.data.limit;
            that.total_count = res.data.total_count;
            that.guidance_type_id = res.data.guidance_type_id;

            var project_id_list = [];
            for (let i = 0; i < that.table_data.length; i++) {
              project_id_list.push(that.table_data[i]["project_id"]);
            }
            if (that.table_data.length > 0) {
              that.project_current_item = that.table_data[that.project_current_index];
              // console.log(that.project_current_item, 666)
              // // 回显需求岗位列表
              // if (that.project_current_item.need_job_data.length > 0) {
              //   that.update_need_job_list = JSON.parse(JSON.stringify(that.project_current_item.need_job_data))
              // } else {
              //   that.update_need_job_list = [{
              //     job_name: '',
              //     need_count: 15, salary_type: '小时', salary: 20, 'job_type': ''
              //   }]
              // }

              setTimeout(() => {
                that.$refs.check.open(that.project_current_item.project_id)
              }, 100);



              that.update_interview_num();
              that.get_project_need_data()
              that.get_health_score()
              // that.$refs.check.open(that.project_current_item.project_id)

            } else {
              that.project_current_item = {};
            }


            // if (res.data.guidance_status) {
            //   setTimeout(() => {
            //     that.$refs.intro1.open();
            //   }, 4000);
            // }

            // 打开
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    basic_info_change(e) {
      console.log('basic_info_change', e)

    },
    project_type_change(e) {
      console.log('项目性质更新', e)
      this.project_current_item.project_type = e
    },

    //跳过完善
    skip_wanshan(project_id) {
      var that = this;
      var obj = {
        project_id: project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/buwanshan", obj, true)
        .then((res) => {
          if (res.code == 0) {
            var route = that.$route;
            var path =
              route.path +
              "/detail" +
              "?tabs_append=" +
              that.interview_status +
              "&project_id=" +
              that.current_item.project_id +
              "&project_name=" +
              that.current_item.project_name;
            // // 打开新窗口1
            open_new_page(path, "_blank");

            // 打开
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取项目列表-数量
    get_my_project_count(project_id_list, status) {
      var that = this;
      var obj = {
        project_id_list: project_id_list,
        status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_interview_count",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var data = res.data.data_dict;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取项目列表-数量
    get_my_project_count_v2(status) {
      var that = this;
      var obj = {
        project_id: this.project_current_item.project_id,
        status: status,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_interview_count_v2",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var data = res.data.data_dict;
            var count = data[this.project_current_item.project_id];
            if (count == undefined) {
              count = 0;
            }
            console.log(status, count);
            that.interview_mainshi_count_dict[status] = count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 更新数量
    update_interview_count(status, data) {
      for (let i = 0; i < this.table_data.length; i++) {
        if (data[this.table_data[i]["project_id"]]) {
          this.table_data[i][status] = data[this.table_data[i]["project_id"]];
        } else {
          this.table_data[i][status] = 0;
        }
      }
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    open_message_list() {
      console.log(this.$refs);

      this.$Notice.info({
        title: "新消息提示",
        desc: "您收到一条新消息，可在【消息中心】查看，请及时处理哟~",
        duration: 0,
        onClose: function () {
          console.log("关闭");
        },
      });

      audio.play();
      // this.$refs.message_list.open()
    },

    update_component() {
      // 项目信息
      this.$refs.project_basic_info.open(this.project_current_item.project_id);
      // 员工借支
      this.$refs.jiezhi_data.open(
        this.project_current_item.project_id,
        this.project_current_item.project_id.project_name
      );
    },

    click_left_project(item, i) {
      this.health_risk_show = false; // 切换项目时先关闭风险弹窗
      this.project_current_index = i;
      this.project_current_item = item; 1
      this.right_menu_index = 0;
      this.$refs.check.open(this.project_current_item.project_id)
      this.update_interview_num();
      this.updateQueryParam('list_index', i)
      this.get_project_need_data()
      this.get_health_score()

    },

    click_swiper_idcard(item) {
      open_new_page('/workbench/swiper_idcard?project_id=' + item.project_id,)
    },

    // 打开项目体检报告
    open_health_check() {
      this.$refs.health_check.open(this.project_current_item);
    },

    // 获取项目上次体检分数（-1 表示未体检）
    get_health_score() {
      var that = this;
      var project_id = this.project_current_item.project_id;
      if (!project_id) {
        this.health_score = null;
        return;
      }
      this.health_score = null; // 请求期间显示占位
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/detail/get_health_score",
        { project_id: project_id },
        true
      )
        .then((res) => {
          if (res.code == 0) {
            var score = res.data.score;
            that.health_score = score == -1 ? -1 : score;
            that.warn_if_risk(project_id, score);
          } else {
            that.health_score = null;
          }
        })
        .catch((res) => {
          console.log(res, "获取体检分数出错");
          that.health_score = null;
        });
    },

    // 上次体检为风险级（低于 75 分）时展示告警弹窗；同一项目本次会话只提醒一次
    warn_if_risk(project_id, score) {
      if (score === null || score === undefined || score == -1) return;
      if (Number(score) >= 75) return;
      if (this.health_warned_project_ids.indexOf(project_id) > -1) return;
      this.health_warned_project_ids.push(project_id);
      this.health_risk_score = score;
      this.health_risk_project_name = this.project_current_item.project_name || "";
      this.health_risk_show = true;
    },

    // 关闭告警弹窗并打开项目体检
    view_health_report() {
      this.health_risk_show = false;
      this.open_health_check();
    },

    add_nedd_job() {
      var item = {
        job_name: "",
        need_count: 10,
        salary: 1,
        salary_type: '小时'
      }
      this.update_need_job_list.push(item)
    },

    universal_form(item) {
      open_new_page('/tools/universal_form?project_id=' + item.project_id,)

    },

    project_name_long_slice(str) {
      var maxLength = 30; // 最大显示长度（英文字符数）
      var currentLength = 0;
      var result = '';

      for (var i = 0; i < str.length; i++) {
        var char = str[i];
        // 判断是否为中文字符（Unicode范围）
        if (char.charCodeAt(0) > 255) {
          currentLength += 2; // 中文字符占2个长度单位
        } else {
          currentLength += 1; // 英文字符占1个长度单位
        }

        // 如果超出最大长度，添加省略号并终止循环
        if (currentLength > maxLength) {
          result += '...';
          break;
        }

        result += char;
      }

      return result;
    }
  },
};
</script>

<style scoped>
.external_name {
  margin: 10px 0 0 15px;
}

.need_job {
  display: flex;
  padding: 0 5px;
}

.job_icon {
  color: #0466dd;
  font-size: 18px;
  margin-right: 5px;
}

.need_job_div2 {
  padding: 5px 10px;
  border: 1px solid #eaeaea;
  margin: 10px 10px 10px 10px;
  border-radius: 3px;
  color: #888;
  display: flex;
  align-items: center;
}

.need_job_div2:hover {
  cursor: pointer;
  border: 1px solid #0466dd
}

.need_job_index {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0466dd;
  color: #fff;
  width: 25px;
}

.need_job_main {
  max-height: 300px;
  padding-right: 10px;
  overflow: auto;
}

.need_job_btn_div {
  display: flex;
  justify-content: center;
  color: #0466dd;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: #f2f2f2;

}

.need_job_btn_div:hover {
  background-color: #d8eafb;

}

.del_job {
  background: #ff4f63;
  color: #fff;
  padding: 5px;
  border-radius: 5px;
}

.del_job:hover {
  cursor: pointer;
  opacity: .7;
}

.need_job_box {}

.need_job_div {
  margin: 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #ececec;
  display: flex;
  justify-content: space-between;

}

.need_job_title {
  width: 100px;
  flex-shrink: 0;
  color: #767676
}

.need_job_inner_div {
  display: flex;
  margin-bottom: 5px;
  align-items: end;
}

.contract_span {
  cursor: pointer;
  color: #0466dd;
}

.iconsfz1 {
  font-size: 18px;
  color: #09b72c;
}

.jiance_number {
  /* font-weight: 600; */
  color: #ed0514;
  padding: 0 2px;
}

.jiance_number:hover {
  color: red;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.jiance_number2 {
  /* font-weight: 600; */
  color: #280e10;
  padding: 0 2px;
}

.jiance_div {
  padding: 5px 10px;
  background: rgb(255, 244, 224);
  color: #333;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}

.jiance_div2 {
  padding: 5px 10px;
  background: rgb(182, 237, 184);
  color: #333;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}

.main2 {
  display: flex;
  width: 100vw;
  height: 100vh;

}

.left_menu_if {
  width: 270px;
  margin-right: 10px;
  flex-shrink: 0;
}

.tingzhi_hezuo:hover {
  cursor: pointer;
  font-weight: 600;
  color: #fa0c0c;
}

.tingzhi_hezuo {
  font-size: 13px;
  margin-right: 10px;
  cursor: pointer;
  color: #f37a7a;
}

.search_div {
  text-align: center;
  padding: 0 0 10px 10px;
}

.project_name_div2 {
  font-weight: 600;
  font-size: 16px;
  color: #121e5b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right_project_name {
  cursor: pointer;
  letter-spacing: 2px;
  border-bottom: 1px solid #e9e9e9;
  background: #e7eaee;
  margin-bottom: 5px;
  text-align: center;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mianshi_box2_name {
  font-size: 13px;
}

.mianshi_box2 {
  height: 65px;
  width: 110px;
  cursor: pointer;
  padding-top: 7px;
  margin: 0px 10px 10px 0;
  background: #fff;
  color: #333;
  border: 1px solid #b8bef7;
  /* box-shadow: 0 0 5px #437fcd; */
  text-align: center;
  border-radius: 5px;
}

.mianshi_box_form {
  height: 65px;
  width: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding-top: 7px;
  margin: 5px 10px 0px 0;
  background: #fff;
  color: #333;
  border: 1px solid #b8bef7;
  /* box-shadow: 0 0 5px #437fcd; */
  text-align: center;
  border-radius: 5px;
}

.mianshi_box_form:hover {
  background: #0466dd;
  color: #fff;
}

.mianshi_box2:hover {
  background: #0466dd;
  color: #fff;
}

.mianshi_box {
  display: flex;
  flex-wrap: wrap;

}

.week_need {
  padding: 5px 15px 0 15px;
  color: #333;
}

.line_name {
  margin-left: 6px;
  color: #333;
  font-weight: 600;
}

.line {
  height: 1px;
  margin: 10px 10px 15px 10px;
  background: #f6f5f5;
}

.line_icon_title {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ececec;
  padding-bottom: 5px;
}

.line_icon {
  height: 15px;
  width: 10px;
  border-radius: 2px;
  background: #0466dd;
}

.current_need_count {
  color: #0466dd;
  cursor: pointer;
}

.right_right {
  padding: 10px;
  background: #fff;
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* .project_right_box_inner {
  width: 100%;
  padding-left: 10px;
  background: orange;
  height: 100%;
} */

.project_right_box_menu_list {
  height: 40px;
  background: #edebeb;
  color: #666666;
  border-radius: 10px 0 0 10px;
  line-height: 40px;
  font-size: 13px;
  padding: 0 3px;
  text-align: center;
  margin-bottom: 5px;
  cursor: pointer;
  display: flex;
  position: relative;
  justify-content: center;
}

.menu_hot {
  width: 23px;
  height: 15px;
  position: absolute;
  top: 1px;
  background-color: red;
  left: 1px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  justify-content: center;
}

.project_right_box_menu_list:hover {
  background: #e6e1e1;
}

.project_right_box_menu_list2 {
  height: 40px;
  border-radius: 10px 0 0 10px;
  color: #fff;
  line-height: 40px;
  font-size: 13px;
  font-weight: 600;
  padding: 0 3px;
  text-align: center;
  cursor: pointer;
  margin-bottom: 5px;
  position: relative;
}

.project_right_box_menu {
  width: 110px;
  /* background: rgb(246, 241, 241); */
  background: #f5f7f9;
  height: 100%;
}

.project_right_box2 {
  position: relative;
  margin-top: 50px;
  top: 60px;
  padding-left: 10px;
  width: calc(100vw - 10px);
  height: calc(100vh - 60px);
}

.project_right_box {
  position: absolute;
  right: 0px;
  top: 50px;
  width: calc(100% - 270px);
  /* width: calc(100% - 5px); */
  /* width: calc(100vw - 280px); */
  height: calc(100vh - 60px);
  /* background: rgb(255, 255, 255); */
  /* box-shadow: 0 0 3px #f3f2f2; */
}

.project_right_inner {
  display: flex;
  height: calc(100vh - 100px);
  min-width: 900px;
}

.left_project_div_list {
  height: calc(100vh - 180px);
  overflow: auto;
}

.project_page {
  border-top: 1px solid #ececec;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.project_name_text {
  font-size: 13px;
}

.project_number {
  width: 25px;
  height: 18px;
  background: #d6dadf;
  color: #fff;
  border-radius: 3px;
  font-size: 11px;
  text-align: center;
  line-height: 18px;
  margin-right: 5px;
}

.project_number2 {
  width: 25px;
  height: 18px;
  background: #ffbf00;
  color: #f1f1f2;
  border-radius: 3px;
  font-size: 11px;
  text-align: center;
  line-height: 18px;
  margin-right: 5px;
}



.top_div {
  display: flex;
  align-items: center;
}

.project_full_name {
  font-size: 12px;
  display: flex;
  color: #bebebe;
  font-weight: 300;
}

.project_list_div_click {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 7px 10px 5px 10px;
  margin: 0 0px;
  background: #0466dd;
  color: #fff;
}

.project_list_div {
  padding: 7px 10px 5px 10px;
  margin: 0 0px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #ececec;
}

.left_project_tab {
  display: flex;
  justify-content: center;
}

.project_left_box {
  width: 260px;
  height: calc(100vh - 60px);
  position: absolute;
  left: 0px;
  top: 50px;
  overflow: auto;
  background: rgb(255, 255, 255);
  box-shadow: 0 0 3px #f3f2f2;
}

.project_introduction {
  padding-bottom: 10px;
}

.tab_div {
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
}

.people_count_div {
  text-align: center;
  display: flex;
  align-items: center;
}

.need_update_title {
  border-radius: 5px;
  background-color: #fef3f2;
  color: #333;
  font-size: 13px;
  padding: 5px 10px;
  margin-bottom: 5px;
}

.need_button_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.need_count {
  color: #0466dd;
  cursor: pointer;
}

.introjs-tooltiptext {
  font-size: 13px;
  padding: 10px 15px;
}

.introjs-tooltip-title {
  font-size: 16px;
  font-weight: 600;
  color: #0466dd;
}

.introjs-button::after {
  border: none;
  background-color: none;
  background: none;
  color: #0466dd;
}

.introjs-button:active {
  border: none;
  outline: none;
  color: #0466dd;
  background-color: none;
  background: none;
}

.introjs-button:hover {
  border: none;
  outline: none;
  color: #0466dd;
  background-color: none;
  background: none;
}

.introjs-button:focus {
  box-shadow: none;
  border: none;
  background-color: none;
  background: none;
  color: #0466dd;
}

.introjs-button {
  background-color: #c4c4c4;
  border-radius: 5px;
  border: none;
  outline: none;
  color: #0466dd;
  margin: 0;
  padding: 5px 10px;
  outline: none;
  background-color: transparent;
  line-height: inherit;
}

.introjs-skipbutton {
  font-size: 14px;
  font-weight: 300;
  color: #e8e8e8 !important;
}
</style>

<style scoped>
.search_notify {
  font-size: 12px;
  color: #ff5555;
}

.project_name {
  cursor: pointer;
  color: #0466dd;
}

.loading_gif {
  width: 12px;
  height: 12px;
}

.hmc_span {
  display: flex;
  justify-content: space-between;
}

.search_box {
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project_type_tag {
  background-color: #ccc;
  padding: 2px 5px;
  margin-right: 5px;
  color: #ffffff;
  border-radius: 3px;
  font-size: 10px;
}

.health_score_tag {
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #19be6b, #0aa85f);
  padding: 2px 9px;
  border-radius: 20px;
  cursor: pointer;
  letter-spacing: 0;
  transition: 0.18s;
  flex-shrink: 0;
}

.health_score_tag:hover {
  opacity: 0.85;
  box-shadow: 0 2px 8px rgba(25, 190, 107, 0.35);
}

.health_score_tag.score-warn {
  background: linear-gradient(135deg, #ff9900, #f28100);
}

.health_score_tag.score-err {
  background: linear-gradient(135deg, #ed4014, #d0320b);
}

.health_score_tag.score-loading {
  background: linear-gradient(135deg, #9aa4b2, #7a8495);
  animation: score-breathe 1.6s ease-in-out infinite;
}

/* 呼吸效果 */
@keyframes score-breathe {

  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(4, 102, 221, 0.25);
  }

  50% {
    box-shadow: 0 0 0 5px rgba(4, 102, 221, 0);
  }
}


.project_name_div {
  padding-right: 10px;
  font-size: 13px;
  color: #0466dd;
  font-weight: 300;
}

.tabs_div {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table_num_title {
  flex-shrink: 0;
  margin-right: 3px;
}

.table_num_div {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.table_click {
  cursor: pointer;
  color: #515a6e;
  width: 100px;
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.table_click:hover {
  color: #0c6ce2;
}

.hmc_span_txt {
  cursor: pointer;
  color: #515a6e;
  margin-right: 10px;
  width: 90px;
  text-align: left;
  display: flex;
  align-items: center;
}

.hmc_span_txt:hover {
  color: #0c6ce2;
}

.table_a {
  cursor: pointer;
  color: #515a6e;
  margin-right: 10px;
  cursor: pointer;
}

.table_a:hover {
  color: #0c6ce2;
}

.table_a_box {
  display: flex;
}

.content_page {
  display: flex;
  justify-content: center;
  padding: 5px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
  background-color: #fff;
  padding: 10px 10px 0 10px;
  border-radius: 5px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: 100%;
  position: absolute;
  right: 0px;
  top: 50px;
  height: calc(100vh - 50px);
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}

/* ===== 体检风险告警弹窗 ===== */
.hc-risk-mask {
  position: absolute;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 5px;
  background: rgba(24, 8, 8, 0.037);
  backdrop-filter: blur(3px);
  animation: hc_risk_fade 0.22s ease both;
}

.hc-risk-card {
  position: relative;
  width: 420px;
  max-width: 92%;
  padding: 36px 30px 30px;
  border-radius: 20px;
  text-align: center;
  overflow: hidden;
  background: linear-gradient(150deg, #8f1810 0%, #c02418 48%, #ef4136 100%);
  box-shadow: 0 30px 80px rgba(120, 20, 14, 0.55), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  animation: hc_risk_pop 0.32s cubic-bezier(0.16, 0.84, 0.44, 1) both;
}

.hc-risk-card::before {
  content: '';
  position: absolute;
  top: -100px;
  right: -80px;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0) 70%);
}

.hc-risk-card::after {
  content: '';
  position: absolute;
  bottom: -120px;
  left: -90px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0) 70%);
}

.hc-risk-card > * {
  position: relative;
  z-index: 1;
}

.hc-risk-close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2;
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.hc-risk-close:hover {
  background: rgba(255, 255, 255, 0.24);
  color: #fff;
  transform: rotate(90deg);
}

.hc-risk-icon {
  width: 66px;
  height: 66px;
  margin: 2px auto 18px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.36);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: hc_risk_pulse 1.8s infinite;
}

.hc-risk-heading {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 3px;
  color: rgba(255, 255, 255, 0.88);
}

.hc-risk-project {
  margin-top: 8px;
  padding: 0 10px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hc-risk-score {
  margin-top: 14px;
  font-size: 52px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -2px;
  color: #fff;
  text-shadow: 0 6px 22px rgba(80, 0, 0, 0.35);
}

.hc-risk-score span {
  font-size: 16px;
  font-weight: 600;
  margin-left: 4px;
  letter-spacing: 0;
}

.hc-risk-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 14px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(0, 0, 0, 0.2);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #fff;
}

.hc-risk-pill i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffd0cb;
  box-shadow: 0 0 0 3px rgba(255, 208, 203, 0.18);
}

.hc-risk-tip {
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.13);
  text-align: left;
  font-size: 13px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.94);
}

.hc-risk-tip b {
  color: #fff;
}

.hc-risk-action {
  width: 100%;
  margin-top: 18px;
  padding: 11px 0;
  border: none;
  border-radius: 10px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #c02418;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(80, 0, 0, 0.25);
  transition: all 0.2s;
}

.hc-risk-action:hover {
  background: #fff5f4;
  box-shadow: 0 8px 24px rgba(80, 0, 0, 0.35);
  transform: translateY(-1px);
}

.hc-risk-action:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(80, 0, 0, 0.25);
}

@keyframes hc_risk_fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hc_risk_pop {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.94);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes hc_risk_pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.45);
  }
  70% {
    box-shadow: 0 0 0 18px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}
</style>
